import Vue from 'vue'
// import moment from 'moment'
// import 'moment/locale/zh-cn'
import { Button, Table, Select, Radio, Input, Tabs, Form, DatePicker, Col, Row, LocaleProvider, message } from 'ant-design-vue'
import FlightCitySelector from '@/components/flightcityselector'
import SimplePagination from '@/components/simple-pagination'

// moment.locale('zh-cn')

Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.use(LocaleProvider)
Vue.use(Button)
Vue.use(Table)
Vue.use(Row)
Vue.use(Col)
Vue.use(Form)
Vue.use(DatePicker)
Vue.use(Select)
Vue.use(Radio)
Vue.use(Input)
Vue.use(Tabs)
Vue.use(FlightCitySelector)
Vue.use(SimplePagination)

Vue.prototype.$message = message
